import { RewardBanner } from '@intigral/shared';
import React from 'react';
import { BannerProps } from '../types/iBanner.types';
import useBannerActions from '../hooks/useBannerActions';

const MlpBanner: React.FC<BannerProps> = ({ carousel }) => {
    const { image, onClickHandler } = useBannerActions(carousel);

    if (!image) {
        return null;
    }

    return (
        <div className="container full-width" style={{ position: 'relative', overflow: 'hidden' }}>
            <RewardBanner image={image} onClick={onClickHandler} isClickable={true} onlyImage className="mlp-banner" />
        </div>
    );
};

export default React.memo(MlpBanner);
